import { createEvent, createStore } from 'effector';
import { useUnit } from 'effector-react';

export const setDirty = createEvent<boolean>();

const $isDirty = createStore(false).on(setDirty, (_, dirty) => dirty);

export const useIsDirty = () => useUnit($isDirty);
